import React, { useMemo, useState } from "react";
import { isZh } from "../utils/language";

export default function ConfirmDangerDialog({
  title,
  message,
  onConfirm,
  onClose,
}) {
  const code = useMemo(
    () => Math.floor(100 + Math.random() * 900).toString(),
    []
  );
  const [input, setInput] = useState("");
  const [processing, setProcessing] = useState(false);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
        <div className="danger">
          <h3>{title}</h3>
          <p>{message}</p>
          <p>
            {isZh()
              ? <>請輸入 <b>{code}</b> 確認</>
              : <>Ketik <b>{code}</b> untuk konfirmasi</>}
          </p>
          <input value={input} onChange={e => setInput(e.target.value)} />
          <button onClick={onClose}>Cancel</button>
          <button
            disabled={input !== code || processing}
            onClick={async () => {
              setProcessing(true);
              await onConfirm();
              setProcessing(false);
            }}
          >
            {processing ? "Deleting..." : "Hapus"}
          </button>
        </div>
      </div>
    </div>
  );
}
